import React from 'react';
import { isEmpty } from 'lodash';
import CardSkeleton from 'components/common/skeleton/CardSkeleton';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import MultiParamSeasonalChart from './MultiParamSeasonalChart';
import MultiPolygonMap from './MultiPolygonMap';
import MultiParamsBarChart from './MultiParamsBarChart';

const ObservationRenderer = ({ observation, loading, coordinates }) => {
  if (loading) {
    return <CardSkeleton footer={false} />;
  }

  return (
    <>
      {!isEmpty(observation) &&
        Object.keys(observation).map((key, index) => (
          <Col
            key={index + key}
            md={observation[key]?.width ? observation[key]?.width : 12}
          >
            {observation[key].type === 'chart' ? (
              observation[key].type_format === 'pie' ? (
                // <ForestCoverMonitorChart data={observation[key]} />
                <></>
              ) : observation[key].type_format === 'seasonal_bar' ? (
                // <MultiParamSeasonalChart
                //   key={index + key + 'seasonal'}
                //   chartData={observation[key]}
                // />
                <></>
              ) : observation[key].type_format === 'bar' ||
                observation[key].type_format === 'line' ? (
                <MultiParamsBarChart
                  key={index + key + 'barline'}
                  type={observation[key].type_format}
                  chartData={observation[key]}
                  info={observation[key].description}
                />
              ) : (
                <></>
              )
            ) : observation[key].type === 'map' ? (
              <React.Fragment key={index + key + 'map'}>
                {observation[key].type_format === 'comparison' ||
                observation[key].type_format === 'normal' ? (
                  <MultiPolygonMap
                    key={index + key + 'multipolygon'}
                    data={observation[key].data}
                    coordinates={coordinates}
                    legendData={observation[key].legend}
                    variant={observation[key].variant}
                    label={observation[key].label}
                    info={observation[key].description}
                  />
                ) : (
                  <></>
                )}
              </React.Fragment>
            ) : (
              <></>
            )}
          </Col>
        ))}
    </>
  );
};

ObservationRenderer.propTypes = {
  observation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  coordinates: PropTypes.array.isRequired
};

export default ObservationRenderer;
